import React, { useEffect, useState } from "react";
import {
  Button,
  Typography
} from "@mui/material";
import Grid from "@material-ui/core/Grid";
import RCard from "./RCard";
import {
  hideApiLoader,
  showApiLoader,
} from "../../../redux/tool-webjam/actions";
import { useDispatch, useSelector } from "react-redux";
import { getPackageList } from "../../paymentRequest";
import { setWillShowDashboard } from "./payment-reducer/actions";
import PackageToogleButton from "./helperComponent/PackageToggleButton";
import "./style.css";
import { connect } from "../../../../base/redux";
import { FEATURE_CUSTOM_PAYMENT, FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V3 } from "../../../constant";
import ButtonLoader from "./helperComponent/ButtonLoader";
import { useDevice, usePrevious } from "../../Utils";
import Loader from 'react-loader';
import { ct, dynamicMessageLocale, translateSubscription } from "../../../constant-Utils";
import { getBaseConfig, handlePaymentWindow } from "../../../Utils";
import { styled } from "@mui/material/styles";
import { formatDate } from "./AbstractHelperComponent";
import { PushSpinner } from "../../../custom/components/PushSpinner";
import {
  setSubscriptionPackage
} from "./../payment/payment-reducer/actions"

const nope = (e) => console.log();

const StyledTypography = styled(Typography)({
  "&.MuiTypography-root": {
    fontSize: "16px",
    mb: 1,
    color: "#333",
  },
});


const PackageList = (props) => {
  const { handleCancelSubscription, isLoading: subscriptionCancelLoading, setPlansCount = nope, plansCount = 0, requestFrom = "page", showApplyCouponModal = false } = props;
  const dispatch = useDispatch();
  const { userPaymentSubscription } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );
  const currentType =
    userPaymentSubscription?.package_type === "year" ? "yearly" : "monthly";
  const [list, setList] = useState("");
  const [activePackageId, setActivePackageId] = useState(null);
  const [checked, setChecked] = useState(false);
  const [subType, setSubType] = useState(currentType);
  const [isLoading, setIsLoading] = useState(false);
  const [isContentLoading, setIsContentLoading] = useState(true);
  const [hasData, setHasData] = useState(false);
  const [isFetching, setFetching] = useState(false);

  useEffect(() => {
    
    setTimeout(() => {
      setIsContentLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    try {

      let apiHit = false;
      // console.log("has subscription ", props)
      if (props.subscriptionPackageList) {
        // console.log("has subscription b ", props)
        if (Object.keys(props.subscriptionPackageList).length) {
          // console.log("has subscription c ", props)
          setList(props.subscriptionPackageList);
        } else {
          apiHit = true;
        }
      }

      console.log("apiHit ",apiHit)

      if (apiHit) {
        setIsLoading(true);
        dispatch(showApiLoader({
          textMessage : "fetchSubscription"
        }));

        setTimeout(() => {
          dispatch(hideApiLoader({
            removeIntention : true
          }));
        },20000)

        getPackageList().then(async (res) => {
          if (res.status == 1) {
            let data = res?.data?.data;
            let finalData = {};
            if (data && data.length) {
              console.log("curre date A", new Date())

              finalData = await (await translateSubscription(data)).titles();
              // data = await Promise.all(data.map(async main => {
              //   main.features = await Promise.all(main.features.map(async feature => {
              //     feature.descriptions = await Promise.all(feature.descriptions.map(async description => {
              //       return await dynamicMessageLocale(description)
              //     }))
              //     feature.title = await dynamicMessageLocale(feature.title)
              //     return feature;
              //   }))
              //   return main;
              // }))
              console.log("curre date B", new Date())
              console.log("curre date C", data)
              // for (let i = 0; i < data.length; i++) {
              //   if (data[i].package_type != undefined) {
              //     if (finalData[data[i].package_type] == undefined) {
              //       finalData[data[i].package_type] = [];
              //     }
              //     finalData[data[i].package_type].push(data[i]);
              //   }
              // }
            }
            setIsLoading(false);
            dispatch(hideApiLoader({
              removeIntention : true
            }));
            if (Object.keys(finalData).length) {
              dispatch(setSubscriptionPackage(finalData))
              setList(finalData);
              setHasData(true);
              let allData = { ...finalData }
              let reformData = []
              Object.keys(allData).forEach(e => reformData.push(allData[e]));
              reformData = _.flatten(reformData)
              let fdata = await (await translateSubscription(reformData)).description();
              setList(fdata);
              dispatch(setSubscriptionPackage(fdata))
            } else {
              setHasData(false);
            }
          } else {
            setIsLoading(false);
            dispatch(hideApiLoader({
              removeIntention : true
            }));
            setHasData(false);
          }
        });
      }
    } catch (e) {
      dispatch(hideApiLoader({
        removeIntention : true
      }));
      console.log("=> err  package ", e);
    }
  }, []);

  const handlePlanSwitch = (type) => {
    // setChecked(e)
    setPlansCount(0);
    setSubType(type);
  };

  const handleSkipPackage = () => {
    if (props.handleSkip) {
      props.handleSkip();
    } else {
      dispatch(setWillShowDashboard(false));
    }
  };

  const renderPackage = (type) => {

    let packList = props.subscriptionPackageList;

    if (packList[type] != undefined) {
      let showPremium = false;
      let allowType = "";
      if (props.hasOwnProperty("showPremium")) {
        if (props.showPremium == true) {
          allowType = "premium"
        }
      }

      let mainList = [...packList[type]];
      if (allowType) {
        mainList = mainList.filter(e => e.name.toLowerCase().indexOf(allowType) != -1)
      }
      if (!plansCount) {
        setPlansCount(mainList.length);
      }
      // let lst = list[type].filter(e => e.name.toLowerCase().indexOf(allowType) != -1)
      // console.log("package list ", list[type], "showBasic", showPremium, { lst })

      return mainList.map((e, i) => {
        return (
          <RCard
            {...e}
            willRefresh={props?.UIrefresh || false}
            key={e.price_id}
            activePackageId={activePackageId}
            setActivePackageId={setActivePackageId}
            handleCloseP={props?.closeSubscription}
            index={i}
            allowPack={allowType}
            plansCount={mainList.length}
            isContentLoading={props.socialTrigger == undefined ? isContentLoading : false}
            requestFrom={props.socialTrigger == undefined ? requestFrom : "" }
            showApplyCouponModal={mainList.length === i + 1 ? showApplyCouponModal : false}
          />
        );
      });
    } else {
      return null;
    }
  };
  const { isMobile, isTablet } = useDevice();
  let curTime = Math.round(new Date().getTime() / 1000);

  const renderCancelSubscriptionButton = (btnStyle) => {
    if (props.hasOwnProperty("hideCancel")) {
      if (props.hideCancel) {
        return null
      }
    }

    return userPaymentSubscription.name &&
      !userPaymentSubscription?.is_canceled && curTime < userPaymentSubscription.end_at && !userPaymentSubscription.is_expired ? (
      subscriptionCancelLoading ? (
        <span style={{ textAlign: "-webkit-center" }} className={btnStyle}><ButtonLoader title={ct("rta-trmc.dashboard.subscription.cancelSubscription")} /></span>
      ) : (
        <Button
          id="cancel-subscription"
          onClick={() => handleCancelSubscription()}
          variant="outlined"
          className={`payment-theme-btn-cancel ${btnStyle}`}
          sx={{
            height: "40px",
          }}
        >
          {ct("rta-trmc.dashboard.subscription.cancelSubscription")}
        </Button>
      )
    ) : null
  }

  const handleDuePayment = (url) => {
    var win = handlePaymentWindow(url);
  }

  const renderDuePayment = (btnStyle) => {
    if (props.hasOwnProperty("hideCancel")) {
      if (props.hideCancel) {
        return null
      }
    }

    if (userPaymentSubscription.is_expired) {
      if (userPaymentSubscription.status == "past_due") {
        return (
          <>
            <div className={`w-100 mb-1  ${btnStyle != "center" ? "text-right" : ""}`}>
              <StyledTypography
                sx={{
                  color: "var(--theme-error-color) !important",
                }}
              >
                {userPaymentSubscription?.due_data?.failure_message}
              </StyledTypography>
            </div>
            {userPaymentSubscription?.due_data?.pay_url ?
              <Button
                id="cancel-subscription"
                onClick={() => handleDuePayment(userPaymentSubscription?.due_data?.pay_url)}
                variant="outlined"
                className={`payment-theme-btn-cancel ${btnStyle}`}
                sx={{
                  height: "40px",
                }}
              >
                {ct("rta-trmc.dashboard.subscription.payDuePayment")}
              </Button> : null
            }
          </>
        )
      }
    }
    return null;
  }
  
  if(props.showLoader && Object.keys(props.textMessage).length){
    return null;
  }
  
  return (
    <>
      {
        !props.conferenceJoined && props.showPrejoinLoader &&
        <>
          {getBaseConfig("showPushSpinnerLoader") ?
            <div className="loader-text-container subsc-list-a">
              <div className='loader-wrapper'>
                <PushSpinner
                  size={30}
                  color="white"
                  loading={false}
                  className={"loader-text-main"}
                />
              </div>
            </div>
            :
            <Loader
              loaded={true}
              options={{
                color: '#fff'
              }}
              className={"loader-text-main"}
            > </Loader>
          }
        </>
      }
      <div
        className="package-main-container"
      // style={{
      //   padding: isMobile ? "0px" : props?.pad || "20px",
      // }}
      >
        {props?.showPackageOnly && (
          <div className="text-center">
            {props?.hideLogo == false ? (
              <div className="m-b-20">
                <img
                  src={"images/logo/rta-login-logo.png"}
                  className="main-logo"
                />
              </div>
            ) : null}
            <div className="m-b-20">
              <h1>{ct("rta-trmc.dashboard.subscription.planTitle")}</h1>
              <Typography
                sx={{
                  fontSize: "16px !important",
                  fontWeight: "500 !important",
                  color: "#000",
                }}
              >
                {ct("rta-trmc.dashboard.subscription.planDesc")}
              </Typography>
            </div>
            {props.additionalTitle && (
              <div className="m-b-20">
                <Typography
                  sx={{
                    fontSize: "16px !important",
                    color: "#000",
                  }}
                >
                  {props.additionalTitle}
                </Typography>
              </div>
            )}
          </div>
        )}

        <Grid container spacing={2} style={{ mt: 0 }} className="subs-time-block">
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={4}
            className={"pt-0"}
          >
            {(isMobile) && (
              <div className="w-100 text-center cancel-subs-btn">
                {/* for mobile view */}
                {renderCancelSubscriptionButton("center")}
                {renderDuePayment("center")}
              </div>
            )}
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4} className={isMobile ? "" : "pt-0"}>
            <div className="w-100 text-center">
              <PackageToogleButton
                handleChange={handlePlanSwitch}
                type={subType}
              />
            </div>
          </Grid>
          {(!isMobile) && (
            <Grid item xs={12} sm={4} md={4} lg={4} className={isMobile ? "" : "pt-0"}>
              <div className="w-100 mobileCenter cancel-subs-btn">
                {/* for desktop view */}
                {renderCancelSubscriptionButton("pull-right")}
                {renderDuePayment("pull-right")}
              </div>
            </Grid>
          )}
        </Grid>

        <Grid container spacing={2} style={{ mt: 0 }}>
          <>{renderPackage(subType == "monthly" ? "month" : "year")}</>
        </Grid>
      </div>
    </>
  );
};
function _mapStateToProps(state) {
  return {
    subscriptionPackageList: state[FEATURE_CUSTOM_PAYMENT].subscriptionPackageList,
    conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
    showPrejoinLoader: state[FEATURE_CUSTOM_REDUX_V3].showPrejoinLoader,
    showLoader: state[FEATURE_CUSTOM_REDUX].showLoader,
    textMessage: state[FEATURE_CUSTOM_REDUX].textMessage
  };
}

export default connect(_mapStateToProps)(PackageList);